import { size } from 'lodash'

const hasContent = (html) => size(html?.replace(/<[^>]*>/g, '')?.trim()) > 0

export default { hasContent }
